<template>
  <div class="wrapper order-wrapper order-detail">
    <section class="section info">
      <template v-if="tradeState=== 'WAIT_PAY'">
        <countdown-circle
          :end-time="detail.tradeInfo.autoCancelTime"
          :start-time="detail.tradeInfo.createTime"
          @on-finish="countdownFinish"
        ></countdown-circle>
      </template>
      <div class="shop" v-if="detail.seller">
        <div class="pic">
          <img v-lazy="getImageUrl(detail.seller.logoUrl,'?imageView2/1/w/54/h/54')">
        </div>
        <div class="name">{{detail.seller.nickName}}</div>
      </div>
      <template v-if="detail.tradeInfo">
        <div class="price">¥{{detail.tradeInfo.payAmount}}</div>
        <div class="status">
          {{tradeState | getTradeStatus}}
          <template
            v-if="tradeState === 'WAIT_CONFIRM_RECEIPT'"
          >（还剩{{detail.tradeInfo.autoComfirmReceiptTime | formatAutoConfirmTime}}自动确认）</template>
        </div>
      </template>
    </section>
    <section class="section goods" v-if="detail.tradeItemList">
      <good-item v-for="item in detail.tradeItemList" :data="item" :show-time="true" :key="item.id"></good-item>
    </section>
    <section
      class="section cell-list"
      v-if="detail.tradeInfo && detail.tradeInfo.tradeType >= 100 && detail.tradeAddress"
    >
      <div class="cell">
        <div class="title">收货信息</div>
        <div class="content">
          {{detail.tradeAddress.name}} {{detail.tradeAddress.phone}}
          <br>
          {{detail.tradeAddress.province}}{{detail.tradeAddress.city}}{{detail.tradeAddress.district}}{{detail.tradeAddress.address}}
        </div>
      </div>
      <div class="cell" v-if="detail.tradeAddress.logisticsNo">
        <div class="title">物流</div>
        <div class="content">
          {{detail.tradeAddress.logisticsCompanyName}}
          <br>
          {{detail.tradeAddress.logisticsNo}}
        </div>
      </div>
    </section>
    <section class="section cell-list">
      <div
        class="cell qr-ticket"
        v-if="detail.tradeInfo && detail.tradeInfo.ticketQr"
        :class="{'is-use': detail.tradeInfo.ticketIsUse}"
      >
        <div class="title">取票</div>
        <div class="content">
          <div class="qr">
            <vue-qrcode
              :value="detail.tradeInfo.ticketQr"
              :options="{ size: 130, foregroundAlpha: detail.tradeInfo.ticketIsUse ? 0.4 : 1, }"
              tag="img"
              @click.native="showBigQr"
            ></vue-qrcode>
          </div>
          <p>
            取票号：
            <span>{{detail.tradeInfo.ticketQr}}</span>
          </p>
        </div>
      </div>
      <template v-for="(item, index) in list">
        <div
          class="cell"
          v-if="get(detail, item.value) !== undefined"
          :key="index"
          :class="item.className"
          v-show="!(item.showFn && item.showFn(get(detail, item.value),detail))"
        >
          <div class="title">{{item.label}}</div>
          <div class="content">
            <template v-if="item.computed">{{item.computed(get(detail, item.value), detail)}}</template>
            <template v-else>{{get(detail, item.value)}}</template>
          </div>
        </div>
      </template>
    </section>
    <!-- 待支付bar -->
    <div class="fixed-bar" v-if="tradeState=== 'WAIT_PAY'">
      <div class="inner">
        <input type="button" class="btn btn-order-cancel" value="取消订单" @click="onCancelOrder">
        <input type="button" class="btn btn-order-pay" value="立即支付" @click="onPay">
      </div>
    </div>
    <!-- 确认收货bar -->
    <div class="fixed-bar" v-if="tradeState=== 'WAIT_CONFIRM_RECEIPT'">
      <div class="inner">
        <input type="button" class="btn btn-order-pay" value="确认收货" @click="onSuccessOrder">
      </div>
    </div>
    <mt-popup class="qr-popup" v-model="popupVisible" popup-transition="popup-fade">
      <div v-if="detail.tradeInfo && detail.tradeInfo.ticketQr">
        <p class="t1">商家扫描此码即可消费</p>
        <div class="qr">
          <vue-qrcode :value="detail.tradeInfo.ticketQr" :options="{ size: 200}" tag="img"></vue-qrcode>
        </div>
        <p class="t2">取票号：{{detail.tradeInfo.ticketQr}}</p>
        <p class="tips">截图保存，以便观展时出示</p>
      </div>
      <div class="close" @click="popupVisible = false"></div>
    </mt-popup>
    <div class="red-packet-content" v-if="hasRedPacket" @click="closeRedPacket">
      <div class="red-packet-close" :class="{'red-packet-show' : hasRedPacket}">
        <div class="courseBefore" :class="{'beforeAnimation' : showOpenPacket}" @click.stop="emptyMethod">
          <div class="redpacket-content">
            <div class="red-bg-top">
              <img class="close" src="../../../assets/img/icon_redpag_close.png" @click="closeRedPacket">
              <p class="desc1">恭喜你获得现金返现</p>
              <p class="desc2">开红包，试试手气</p>
            </div>
            <div class="red-bg-bottom"></div>
            <img class="open-image" src="../../../assets/img/icon_redpag_open.png" @click.stop="openRedpcketAction">
          </div>
        </div>
        <div class="courseAfter" :class="{'afterAnimation' : showOpenPacket}" @click.stop="emptyMethod">
          <div class="redpacket-content">
            <div class="red-bg-top">
              <div class="money-bg"></div>
              <img class="close" src="../../../assets/img/icon_redpag_close.png" @click="closeRedPacket">
              <img class="fire-flower" src="../../../assets/img/icon_redpag_firework.png" @click.stop="emptyMethod">
              <p class="desc3">已存入在艺零钱，请登录在艺App查看</p>
              <div class="money-content">
                <p class="money-left">¥</p>
                <p class="money-right">{{redAmount}}</p>
              </div>
            </div>
            <div class="red-bg-bottom"></div>
            <p class="desc4">{{redPacketData.message || '看完写点评，更可获20积分'}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash.get'
import queryString from 'query-string'
import {
  getImageUrl,
  getTradeStatus,
  formatDateTime,
  formatAutoConfirmTime
} from '@/utils/utils'
import {
  getOrderDetail,
  closeOrder,
  receiveOrder,
  getRedPacketCheckData,
  openRedPacket
} from '@/api/order'
import CountdownCircle from '@/components/CountdownCircle'
import GoodItem from './GoodItem'
import VueQrcode from '@xkeshi/vue-qrcode'
import { share } from '@/utils/share'

export default {
  name: 'OrderDetail',
  components: { CountdownCircle, GoodItem, VueQrcode },
  metaInfo: { title: '订单详情' },
  data() {
    return {
      pid: '',
      redirect_uri: '',
      detail: {},
      tradeState: '',
      hasRedPacket: false,
      showOpenPacket: false,
      redAmount: 0,
      redPacketData: {},
      list: [
        {
          label: '使用有效期',
          value: 'tradeInfo.ticketEndTime',
          computed: formatDateTime
        },
        { label: '物流', value: 'tradeInfo.tradeAddress.logisticsCompanyName' },
        { label: '商品金额', value: 'tradeInfo.goodAmount' },
        { label: '运费', value: 'tradeInfo.freightAmount' },
        { label: '优惠金额', value: 'tradeInfo.tradeDiscount' },
        {
          label: '需付',
          value: 'tradeInfo.payAmount',
          showFn(value, detail) {
            return detail.tradeInfo.payState === 'SUCCESS'
          },
          computed(value, order) {
            let payAmount = order.tradeInfo.payAmount
            let creditAmount = order.tradeInfo.creditAmount
            let result = ''
            if (payAmount || !creditAmount) {
              result += `¥${payAmount}`
            }
            if (payAmount && creditAmount) {
              result += `+`
            }
            if (creditAmount) {
              result += `${creditAmount}积分`
            }
            return result
          }
        },
        {
          label: '实付',
          value: 'tradeInfo.payAmount',
          showFn(value, detail) {
            return detail.tradeInfo.payState !== 'SUCCESS'
          },
          computed(value, order) {
            let payAmount = order.tradeInfo.payAmount
            let creditAmount = order.tradeInfo.creditAmount
            let result = ''
            if (payAmount || !creditAmount) {
              result += `¥${payAmount}`
            }
            if (payAmount && creditAmount) {
              result += `+`
            }
            if (creditAmount) {
              result += `${creditAmount}积分`
            }
            return result
          }
        },
        {
          label: '付款方式',
          value: 'tradeInfo.payType',
          computed: value => {
            var options = {
              NONE: '无',
              WXPay: '微信',
              ALIPay: '支付宝',
              APPLEInner: '苹果内购',
              APPLEPay: '苹果支付',
              ZYB: '在艺币',
              LIVE: '直播收入',
              LingQian: '零钱'
            }
            return options[value]
          }
        },
        { label: '商品说明', value: 'tradeInfo.body' },
        { label: '订单编号', value: 'tradeInfo.id' },
        {
          label: '创建时间',
          value: 'tradeInfo.createTime',
          computed: formatDateTime
        },
        {
          label: '付款时间',
          value: 'tradeInfo.payTime',
          computed: formatDateTime
        },
        {
          label: '发货时间',
          value: 'tradeInfo.shipTime',
          computed: formatDateTime
        },
        {
          label: '完成时间',
          value: 'tradeInfo.tradeCompleteTime',
          computed: formatDateTime
        },
        {
          label: '使用时间',
          value: 'tradeInfo.ticketUseTime',
          computed: formatDateTime
        },
        {
          label: '取消时间',
          value: 'tradeInfo.tradeCancelTime',
          computed: formatDateTime
        },
        {
          label: '退款金额',
          value: 'tradeInfo.returnAmount',
          showFn: function(value) {
            return !value > 0
          }
        },
        { label: '退款时间', value: 'tradeInfo.tradeReturnTime' }
      ],
      popupVisible: false
    }
  },
  filters: { getTradeStatus, formatAutoConfirmTime },
  methods: {
    get,
    getImageUrl,
    getDetail() {
      getOrderDetail({ id: this.pid }).then(response => {
        this.detail = Object.assign({}, this.detail, response.data)
        this.tradeState = this.detail.tradeInfo.tradeState || ''
      })
    },
    // 取消订单之前
    onCancelOrder() {
      this.$messagebox({
        title: '确认要取消订单？',
        message: '订单取消后将直接被删除，如需购买请重新下单。',
        showCancelButton: true,
        confirmButtonText: '确认'
      }).then(action => {
        if (action === 'confirm') {
          this.cancelOrder()
        }
      })
    },
    // 取消订单
    cancelOrder() {
      closeOrder({ tradeId: this.pid }).then(response => {
        this.detail = Object.assign({}, this.detail, response.data)
        this.tradeState = 'CANCEL'
      })
    },
    // 确认收货
    onSuccessOrder() {
      receiveOrder({ tradeId: this.pid }).then(response => {
        this.detail = Object.assign({}, this.detail, response.data)
        this.tradeState = 'SUCCESS'
      })
    },
    // 检查是否有红包
    checkRedPacketData() {
      getRedPacketCheckData({ tradeId: this.pid }).then(response => {
        if (response.data.id && !response.data.isOpen) {
          this.hasRedPacket = true
          this.redAmount = response.data.amount
          this.redPacketData = response.data
        }
        console.log(response)
      })
    },
    // 开红包
    openRedPacket() {
      openRedPacket({ id: this.redPacketData.idStr }).then(response => {
        console.log(response)
      })
    },
    countdownFinish() {
      this.tradeState = 'CANCEL'
      // this.getDetail()
    },
    onPay() {
      let query = queryString.stringify({
        trade_id: this.pid,
        open_id: this.detail.buyer.openIdStr,
        redirect_uri: this.redirect_uri
      })
      location.href = `${process.env.VUE_APP_WEBAPP_PAY_URL}/?${query}`
    },
    showBigQr() {
      if (this.detail.tradeInfo.ticketIsUse) {
        return false
      }
      this.popupVisible = true
    },
    // 打开红包
    openRedpcketAction() {
      this.openRedPacket()
      this.showOpenPacket = true
    },
    closeRedPacket() {
      this.hasRedPacket = false
    },
    emptyMethod() {}
  },
  created() {
    this.pid = this.$route.params.id
    this.getDetail()
    this.checkRedPacketData()
    // this.hasRedPacket = true
    // 分享语设置
    share({
      title: '在艺App',
      desc: '爱艺术的人都在这里',
      link: 'https://www.zai-art.com',
      imgUrl: 'https://img.zai-art.com/logo/512.png'
    })
  }
}
</script>
<style src='@/assets/css/order.css'></style>
